import React from "react";

const PrivacyIcon = ({ size = 20, className = "", strokeWidth = 2 }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Schild + Schloss */}
    <path d="M12 3l7 3v5c0 5-3.5 8.5-7 10-3.5-1.5-7-5-7-10V6l7-3z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round"/>
    <rect x="9" y="10.5" width="6" height="5.5" rx="1.5" stroke="currentColor" strokeWidth={strokeWidth}/>
    <path d="M10.5 10.5V9a1.5 1.5 0 013 0v1.5" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round"/>
  </svg>
);

export default PrivacyIcon;
